import { c as _c } from "react/compiler-runtime";
import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import type { CustomQuestionsFormData, Question } from '../types';
import AddressPreview from './questions/address/address-preview';
import CheckboxPreview from './questions/checkbox/checkbox-preview';
import CheckboxesPreview from './questions/checkboxes/checkboxes-preview';
import DropdownPreview from './questions/dropdown/dropdown-preview';
import LongTextPreview from './questions/long-text/long-text-preview';
import MultipleChoicePreview from './questions/multiple-choice/multiple-choice-preview';
import NumberPreview from './questions/number/number-preview';
import QuestionContainer from './questions/question-container';
import ShortTextPreview from './questions/short-text/short-text-preview';
import TextBlockPreview from './questions/text-block/text-block-preview';
type QuestionPreviewProps = {
  question: Question;
  questionIndex: number;
  isSelected: boolean;
  onClick: () => void;
  onDelete: () => void;
  dragAttributes?: DraggableAttributes;
  dragListeners?: SyntheticListenerMap;
  canEdit: boolean;
};
const QuestionPreview = t0 => {
  const $ = _c(54);
  const {
    question,
    questionIndex,
    isSelected,
    onClick,
    onDelete,
    dragAttributes,
    dragListeners,
    canEdit
  } = t0;
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    errors
  } = useFormState(t2);
  const t3 = `questions.${questionIndex}.condition`;
  let t4;
  if ($[3] !== control || $[4] !== t3) {
    t4 = {
      control,
      name: t3
    };
    $[3] = control;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const condition = useWatch(t4);
  const t5 = !!errors.questions?.[questionIndex];
  const t6 = !!condition;
  let t7;
  if ($[6] !== question.kind || $[7] !== questionIndex) {
    t7 = question.kind === "text_block" && <TextBlockPreview questionIndex={questionIndex} />;
    $[6] = question.kind;
    $[7] = questionIndex;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== question.kind || $[10] !== questionIndex) {
    t8 = question.kind === "short_text" && <ShortTextPreview questionIndex={questionIndex} />;
    $[9] = question.kind;
    $[10] = questionIndex;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== question.kind || $[13] !== questionIndex) {
    t9 = question.kind === "long_text" && <LongTextPreview questionIndex={questionIndex} />;
    $[12] = question.kind;
    $[13] = questionIndex;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== question.kind || $[16] !== questionIndex) {
    t10 = question.kind === "number" && <NumberPreview questionIndex={questionIndex} />;
    $[15] = question.kind;
    $[16] = questionIndex;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== question.kind || $[19] !== questionIndex) {
    t11 = question.kind === "dropdown" && <DropdownPreview questionIndex={questionIndex} />;
    $[18] = question.kind;
    $[19] = questionIndex;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== question.kind || $[22] !== questionIndex) {
    t12 = question.kind === "checkboxes" && <CheckboxesPreview questionIndex={questionIndex} />;
    $[21] = question.kind;
    $[22] = questionIndex;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== question.kind || $[25] !== questionIndex) {
    t13 = question.kind === "checkbox" && <CheckboxPreview questionIndex={questionIndex} />;
    $[24] = question.kind;
    $[25] = questionIndex;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== question.kind || $[28] !== questionIndex) {
    t14 = question.kind === "multiple_choice" && <MultipleChoicePreview questionIndex={questionIndex} />;
    $[27] = question.kind;
    $[28] = questionIndex;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== question.kind || $[31] !== questionIndex) {
    t15 = question.kind === "address" && <AddressPreview questionIndex={questionIndex} />;
    $[30] = question.kind;
    $[31] = questionIndex;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
    t16 = <fieldset disabled={true} className="contents pointer-events-none">{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}</fieldset>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== canEdit || $[44] !== dragAttributes || $[45] !== dragListeners || $[46] !== isSelected || $[47] !== onClick || $[48] !== onDelete || $[49] !== question.id || $[50] !== t16 || $[51] !== t5 || $[52] !== t6) {
    t17 = <QuestionContainer isSelected={isSelected} onClick={onClick} onDelete={onDelete} hasError={t5} hasCondition={t6} dragAttributes={dragAttributes} dragListeners={dragListeners} canEdit={canEdit} key={question.id}>{t16}</QuestionContainer>;
    $[43] = canEdit;
    $[44] = dragAttributes;
    $[45] = dragListeners;
    $[46] = isSelected;
    $[47] = onClick;
    $[48] = onDelete;
    $[49] = question.id;
    $[50] = t16;
    $[51] = t5;
    $[52] = t6;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  return t17;
};
export default QuestionPreview;